// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--xpGIZ","menu":"styles-module--menu--BTxo2"};